import React, { useEffect, useState } from 'react';

const ProductDetailItem = ({ label, value, valueClass = 'gray_dark_01', productUrl = '', postUrl = '' }) => {
	return (
		<li className="regular-12 d-flex justify-content-start">
			<span className="subtitle gray_dark_05">{label}</span>
			<span className="clone">:</span>
			<span className={`sub-info ${valueClass} weight-500 ${label === 'Description' ? 'w-100' : ''}`}>
				{valueClass === 'blue' ? (
					<a href={productUrl || postUrl || ''} target={'_blank'} rel="noreferrer">
						{value}
					</a>
				) : (
					value
				)}
			</span>
		</li>
	);
};

const ProductDescription = ({ singleProduct, markAsError }) => {
	const {
		market,
		category,
		source,
		productUrl,
		postUrl,
		fabricType,
		keyComposition,
		price,
		graphicsType,
		color,
		graphicsContent,
		description,
		isError,
		brandName,
		userName,
		fabricTypeList
	} = singleProduct;
	const [error, setError] = useState(isError);

	const changeMarkAsError = async (e) => {
		const isChecked = e.target.checked;
		setError(isChecked);
		await markAsError(isChecked);
	};

	useEffect(() => {
		setError(isError);
	}, [isError]);

	return (
		<div className="slider-info">
			<div className="product-description">
				<ul>
					{market && <ProductDetailItem label="Market" value={market || ''} />}
					{category && <ProductDetailItem label="Category" value={category || ''} />}
					{source && (productUrl || postUrl) && (
						<ProductDetailItem
							label="Source"
							value={source === 'BRAND' ? brandName : source === 'INSTAGRAM' ? userName : ''}
							valueClass="blue"
							productUrl={productUrl}
							postUrl={postUrl}
						/>
					)}
					{fabricTypeList && (
						<ProductDetailItem
							label="Fabric"
							value={[
								...fabricTypeList.map((item) => item),
								keyComposition ? `${keyComposition}` : ''
							]
								.filter(Boolean)
								.join(', ')}
						/>
					)}
					{fabricType && <ProductDetailItem label="Fabric" value={fabricType || ''} />}
					{price && <ProductDetailItem label="Price" value={`$${price || ''}`} />}
					{graphicsType && <ProductDetailItem label="Graphic Type" value={graphicsType || ''} />}
					{color && <ProductDetailItem label="Color" value={color || ''} />}
					{graphicsContent && (
						<ProductDetailItem label="Graphic Content" value={graphicsContent || ''} />
					)}
					{description && <ProductDetailItem label="Description" value={description || ''} />}
				</ul>
			</div>

			<div className="mark-checkbox custom-chekbox d-flex justify-content-start align-items-center">
				<div className="form-group">
					<input
						onChange={changeMarkAsError}
						type="checkbox"
						id="person2"
						name="Company"
						checked={error}
					/>
					<label className="regular-14 gray_dark_03" htmlFor="person2">
						<span className="">Mark as info error</span>
					</label>
				</div>
			</div>
		</div>
	);
};

export default ProductDescription;
